import { toast } from "sonner";
import type { NavigateFunction } from "react-router";

import { ChatReadyToast } from "./ChatReadyToast";
import {
    forgetChatReadyToast,
    reserveChatReadyToastSlot,
} from "./chatReadyToastRegistry";

export function showChatReadyToast(
    title: string | undefined,
    remoteId: string,
    navigate: NavigateFunction
) {
    const href = `/organizations/chat/${remoteId}`;
    reserveChatReadyToastSlot(remoteId);
    toast.custom(
        () => (
            <ChatReadyToast
                title={title ?? ""}
                actionHref={href}
                onAction={() => {
                    toast.dismiss(remoteId);
                    navigate(href);
                }}
                onDismiss={() => toast.dismiss(remoteId)}
            />
        ),
        {
            id: remoteId,
            duration: Infinity,
            onDismiss: () => forgetChatReadyToast(remoteId),
        }
    );
}
